module.exports = __webpack_public_path__ + "media/newstyle/images/icon-separated-cover-b2f0df27eb9296c82baa869acfb722b8.svg";